const checkOverflow = (element: HTMLElement): boolean => {
  // Compare scrollHeight (full content) with clientHeight (visible area)
  return element.scrollHeight > element.clientHeight;
};

const setupCollectionDescription = () => {
  const wrapper = document.querySelector<HTMLElement>(
    '.js-description-wrapper'
  );
  const toggleWrapper = document.querySelector<HTMLElement>(
    '.js-description-toggle-wrapper'
  );
  const toggleBtn = document.querySelector<HTMLButtonElement>(
    '.js-description-toggle'
  );
  const readMoreText =
    toggleWrapper?.querySelector<HTMLElement>('.js-read-more-text');
  const readLessText =
    toggleWrapper?.querySelector<HTMLElement>('.js-read-less-text');

  if (
    !wrapper ||
    !toggleWrapper ||
    !toggleBtn ||
    !readMoreText ||
    !readLessText
  ) {
    return;
  }

  // Function to check and show/hide toggle based on overflow
  const checkAndToggleVisibility = () => {
    const isExpanded = wrapper.classList.contains('line-clamp-none');

    // If expanded, preserve the expanded state and check overflow in collapsed state
    if (isExpanded) {
      // Temporarily remove line-clamp-none to check if content would overflow when collapsed
      wrapper.classList.remove('line-clamp-none');
      wrapper.classList.add('line-clamp-3');
      const wouldOverflow = checkOverflow(wrapper);
      // Restore expanded state
      wrapper.classList.remove('line-clamp-3');
      wrapper.classList.add('line-clamp-none');

      // Show toggle if content would overflow when collapsed
      if (wouldOverflow) {
        toggleWrapper.classList.remove('hidden');
      } else {
        toggleWrapper.classList.add('hidden');
      }
    } else {
      // Only check overflow and update toggle when in collapsed state
      if (checkOverflow(wrapper)) {
        toggleWrapper.classList.remove('hidden');
      } else {
        toggleWrapper.classList.add('hidden');
      }
    }
  };

  // Initial check
  checkAndToggleVisibility();

  // Handle window resize (viewport width changes affect line-clamp)
  let resizeTimeout: number;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(checkAndToggleVisibility, 100);
  });

  toggleBtn.addEventListener('click', () => {
    const isExpanded = wrapper.classList.contains('line-clamp-none');

    if (isExpanded) {
      // Collapse
      wrapper.classList.remove('line-clamp-none');
      wrapper.classList.add('line-clamp-3');
      toggleBtn.setAttribute('aria-expanded', 'false');
      readMoreText.classList.remove('hidden');
      readLessText.classList.add('hidden');
    } else {
      // Expand
      wrapper.classList.remove('line-clamp-3');
      wrapper.classList.add('line-clamp-none');
      toggleBtn.setAttribute('aria-expanded', 'true');
      readMoreText.classList.add('hidden');
      readLessText.classList.remove('hidden');
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupCollectionDescription);
} else {
  setupCollectionDescription();
}
